import config from 'config'

export const tabs = [
  {
    id: 1,
    label: 'My Events',
    intlKey: 'tabs.my_events',
    path: `/my-events`,
    type: 'tab'
  },
  {
    id: 2,
    label: 'All Events',
    intlKey: 'tabs.all_events',
    path: `/all-events`,
    type: 'tab'
  },
  {
    id: 3,
    label: 'AJ Templates',
    intlKey: 'tabs.aj_templates',
    path: `/templates`
  },
  {
    id: 4,
    label: 'New Template',
    intlKey: 'tabs.new_template',
    path: `${config.publicPath}/adventurous-journeys/templates/new`,
    type: 'action',
    secondary: true
  },
  {
    id: 5,
    label: 'New AJ event',
    intlKey: 'tabs.new_aj_event',
    path: `${config.publicPath}/adventurous-journeys/new`,
    type: 'action'
  }
]

export const tabsMyEvents = [
  {
    id: 1,
    label: 'Detail',
    intlKey: 'tabs.detail',
    path: `/detail`
  },
  {
    id: 2,
    label: 'Participants',
    intlKey: 'tabs.participants',
    path: `/event-participants`
  },
  {
    id: 3,
    label: 'Additional files',
    intlKey: 'tabs.additional_files',
    path: `/files`
  }
]

export const root = `${config.publicPath}/adventurous-journeys`
export const rootMyEvents = `${config.publicPath}/adventurous-journeys/my-events`
export const rootAllEvents = `${config.publicPath}/adventurous-journeys/all-events`

export const tableHeaders = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'Name',
    intlKey: 'table.name',
    sortableId: 'title'
  },
  {
    id: 3,
    label: 'Journey Category',
    intlKey: 'table.journey_category',
    sortableId: 'ajEventCategory.value'
  },
  {
    id: 4,
    label: 'Journey Activity',
    intlKey: 'table.journey_activity',
    sortableId: 'activityCategory.id'
  },
  {
    id: 5,
    label: 'Journey Type',
    intlKey: 'table.journey_type',
    sortableId: 'activityCategory.parent.id'
  },
  {
    id: 6,
    label: 'Award Level',
    intlKey: 'table.award_level',
    sortableId: 'awardLevel.value'
  },
  {
    id: 7,
    label: 'Award Unit',
    intlKey: 'table.award_unit',
    sortableId: 'organization.name'
  },
  {
    id: 8,
    label: 'Start Date',
    intlKey: 'table.start_date',
    sortableId: 'startDate'
  },
  {
    id: 9,
    label: 'End Date',
    intlKey: 'table.end_date',
    sortableId: 'endDate'
  },
  {
    id: 10,
    label: 'Created by',
    intlKey: 'table.created_by'
  },
  {
    id: 11,
    label: 'Participants',
    intlKey: 'table.participants'
  }
]

export const participantsTableHeaders = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name'
  },
  {
    id: 4,
    label: 'Team Goal',
    intlKey: 'table.team_goal'
  },
  {
    id: 5,
    label: 'Finished',
    intlKey: 'table.finished'
  },
  {
    id: 6,
    label: 'Assessor approve',
    intlKey: 'table.assessor_approve'
  },
  {
    id: 7,
    label: 'Observations',
    intlKey: 'table.observations'
  },
  {
    id: 9,
    label: 'Actions',
    intlKey: 'table.actions'
  }
]

export const participantsTableHeadersSecondary = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 2,
    label: 'Started',
    intlKey: 'table.started_at'
  },
  {
    id: 3,
    label: 'Assessor Report',
    intlKey: 'table.assessor_report'
  },
  {
    id: 5,
    label: 'Actions',
    intlKey: 'table.actions',
    right: true
  }
]

export const infoTable = [
  {
    id: 1,
    label: 'Adventurous Journey detail',
    intlKey: 'table.adventurous_journey_detail'
  },
  {
    id: 2,
    label: 'Started',
    intlKey: 'table.started_at'
  },
  {
    id: 3,
    label: 'Assessor approve',
    intlKey: 'table.assessor_approve'
  },
  {
    id: 4,
    label: 'Assessor Report',
    intlKey: 'table.assessor_report'
  }
]
